<template>
  <c-grid>

    <c-grid-item
      v-if="($is(['applicant', 'css_supervisor'])) && ratings.user"
      :span="$is(['css_supervisor']) ? 6 : null"
    >

      <c-title
        v-if="$is(['css_supervisor'])"
        tag="h2"
      >
        {{ userName }} bewertet {{ reviewerName }}
      </c-title>
      <c-process-rating-list-cards
        :allow-rating="$is(['applicant'])"
        :process="process"
        :ratings="ratings.user"
      />

    </c-grid-item>

    <c-grid-item
      v-if="($is(['professor', 'css_supervisor'])) && ratings.reviewer"
      :span="$is(['css_supervisor']) ? 6 : null"
    >

      <c-title
        v-if="$is(['css_supervisor'])"
        tag="h2"
      >
        {{ reviewerName }} bewertet {{ userName }}
      </c-title>
      <c-process-rating-list-cards
        :allow-rating="$is(['professor'])"
        :process="process"
        :ratings="ratings.reviewer"
      />

    </c-grid-item>

  </c-grid>
</template>

<script>
import CCard from '@/components/CCard'
import CGrid from '@/components/CGrid'
import CGridItem from '@/components/CGridItem'
import CRating from '@/components/CRating'
import CTitle from '@/components/CTitle'
import CProcessRatingListCards from '@/components/process/CProcessRatingListCards'

export default {
  name: 'CProcessRatingList',

  components: {
    CCard,
    CGrid,
    CGridItem,
    CRating,
    CTitle,
    CProcessRatingListCards
  },

  props: {
    ratings: {
      type: Object,
      required: true
    },

    process: {
      type: Object,
      required: true
    }
  },

  computed: {
    userName () {
      return this.process.user.first_name + ' ' + this.process.user.last_name
    },
    reviewerName () {
      return this.process.reviewer.first_name + ' ' + this.process.reviewer.last_name
    }
  }
}
</script>
